import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";

import axios from "axios";

import {
  PanelHeader, 
  Button,
  Timeline
} from "components";

import { thead, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";

// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const NOTA = "nota";
const noteType = [
  { value: "59", label: "General" },
  { value: "60", label: "Incidencia" },
  { value: "62", label: "Log" },
  { value: "61", label: "Solución" },
  { value: "214", label: "Devolución" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];

class BillDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      areItemsLoading: false,
      currentBillID: this.props.match.params.orderNumber in this.props.mainState.orders_ids ? this.props.mainState.orders_ids[this.props.match.params.orderNumber] : null
    };
    /* ////console.log(props); */
    this.createRightColumn = this.createRightColumn.bind(this);
    this.getNotes = this.getNotes.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.showPopUpConfirmation = this.showPopUpConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.newNoteConfirmation = this.newNoteConfirmation.bind(this);
    this.validateNewNote = this.validateNewNote.bind(this);
  }
  getNotes(order_id) {
    this.props.getCustomerNotes(order_id);
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.state.currentBillID && this.props.match.params.orderNumber in this.props.mainState.orders_ids) {
      this.setState({
        currentBillID: this.props.mainState.orders_ids[this.props.match.params.orderNumber]
      });
      this.getNotes(this.props.mainState.orders_ids[this.props.match.params.orderNumber]);
    }
  }
  componentDidMount() {
    if (!this.state.areItemsLoading && !(this.props.match.params.orderNumber in this.props.mainState.ordersArticles)) {
      this.props.getOrdersArticles(this.props.match.params.orderNumber, null, null, null, true);
      this.setState({ areItemsLoading: true });
    }
    if (!(this.props.match.params.orderNumber in this.props.mainState.orders_ids)) {
      this.props.getOrderID(this.props.match.params.orderNumber);
    }
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      noteText: "",
      noteTitle: "",
      noteType: ""
    });
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case NOTA:
        return this.createNotePopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  createNotePopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Escribir nota"
        onConfirm={() => this.showPopUpConfirmation(NOTA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Guardar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Tipo</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Tipo de nota"
                  name="noteType"
                  value={this.state.noteType}
                  options={noteType}
                  onChange={value => this.setState({ noteType: value })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Label md={3}>Título</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Input
                  type="text"
                  name="noteTitle"
                  placeholder="Título de la nota"
                  value={this.state.noteTitle}
                  onChange={event => this.setState({ noteTitle: event.target.value })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col size={12}>
              <FormGroup>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case NOTA:
        this.newNoteConfirmation();
        break;
      default:;
    }
  }
  newNoteConfirmation() {
    if (!this.validateNewNote()) {
      return;
    }
    //console.log("################## SHOW POP UP CONFIRMATION ################");
    //console.log(this.state);
    this.props.createNote(
      this.state.noteType.value,
      this.state.noteTitle,
      this.state.noteText,
      this.state.currentBillID
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Añadida!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          La nota ha sido añadida.
        </SweetAlert>
      )
    });
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  validateNewNote() {
    let validation = true;
    if (this.state.noteText === "") validation = false;
    return validation;
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  createRightColumn() {
    let rightColumn = [];
    rightColumn.push(<br />);
    // if (!(this.props.mainState.user.field_tipo_distribuidor.und && 
    //       this.props.mainState.user.field_tipo_distribuidor.und[0].tid === 180)) {
    //   rightColumn.push(
    //     <Card size={12} key="buttonsCard">
    //       <CardBody>{this.createActionButtons()}</CardBody>
    //     </Card>
    //   );
    // }

    let notesCardHeader = (
        <CardHeader className="txt-black">
          <h5>
            <i className="now-ui-icons design-2_ruler-pencil" /> Notas{"  "}
            <Button
              icon
              round
              key={"createNoteButton"}
              color="info"
              onClick={() => {
                this.showPopUp(NOTA);
              }}
              leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
            />
          </h5>
        </CardHeader>
    );

    let notesCard = null;
    let notesCardBody = null;
    if (parseInt(this.state.currentBillID) in this.props.mainState.customerNotes) {
      let customerNotes = this.props.mainState.customerNotes[this.state.currentBillID];
      if (!customerNotes) customerNotes = [];
      if (customerNotes.length > 0) {
        customerNotes = customerNotes.map((note, key) => {
          let badgeStyle = 
          {
            color: "default",
            icon: "travel_info"
          };
          if (note.tipo === "Incidencia") {
            badgeStyle.color = "danger";
            badgeStyle.icon = "ui-2_settings-90";
          }
          if (note.tipo === "Solución") {
            badgeStyle.color = "primary";
            badgeStyle.icon = "ui-2_like";
          }
          if (note.tipo === "Log") {
            badgeStyle.color = "warning";
            badgeStyle.icon = "ui-1_bell-53";
          }
          if (note.tipo === "Pago") {
            badgeStyle.color = "primary";
            badgeStyle.icon = "business_money-coins";
          }
          let note_text = note.texto;
          // console.log("note_text", note_text);
          try {
            let note_json = JSON.parse(note_text);
            // console.log("note_json", note_json);
            note_text = note_json.text;
          } catch (error) {
            // console.log("error", error);
            note_text = note.texto;
          }

          return {
            inverted: true,
            badgeColor: badgeStyle.color,
            badgeIcon: "now-ui-icons " + badgeStyle.icon,
            title: note.autor + (note.titulo !== "" ? ": " + note.titulo : ""),
            titleColor: "danger",
            body: <div dangerouslySetInnerHTML={{ __html: note_text }} />,
            footerTitle: <div dangerouslySetInnerHTML={{ __html: note.fecha }} />
          };
        });
        notesCardBody =
          <CardBody>
            <Timeline stories={customerNotes} simple />
          </CardBody>;
      } else {
        notesCardBody = 
          <CardBody>
            <div>
              <i className="now-ui-icons ui-1_simple-remove" /> No hay notas
            </div>
          </CardBody>;
      }
    } else if(parseInt(this.state.currentBillID) in this.props.mainState.isSearchingCustomerNotes || !this.state.currentBillID) {
      if (this.props.mainState.isSearchingCustomerNotes[parseInt(this.state.currentBillID)]) {
        notesCardBody = 
          <CardBody>
            <div>
              <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
            </div>
          </CardBody>;
      }
    }
    notesCard = (
      <Card key="notesCard" className="card-plain card-timeline">
        {notesCardHeader}
        {notesCardBody}
      </Card>
    );
    rightColumn.push(notesCard);

    if (rightColumn.length > 0) {
      return (
        <Col md={4} xs={12}>
          {rightColumn}
        </Col>
      );
    } else {
      return null;
    }
  }
  goBack() {
    window.history.back();
  }
  render() {
    let contentToDisplay = null;
    if(this.props.match.params.orderNumber in this.props.mainState.ordersArticles){
      let currentOrderItems = this.props.mainState.ordersArticles[this.props.match.params.orderNumber];
      contentToDisplay = 
        <Col xs={12}>
          <Card> 
              <CardBody>
                <Button
                  color="info"
                  size="sm"
                  onClick={e =>
                    this.goBack()
                  }
                >
                  <div>
                    <i className="now-ui-icons arrows-1_minimal-left" />   Volver
                  </div>
                </Button>
              </CardBody>     
            <CardHeader>
              <CardTitle tag="h4">Detalle de factura nº {this.props.match.params.orderNumber}</CardTitle>
            </CardHeader>
            <CardBody>
              <Table responsive>
                <thead>
                  <tr className="text-primary">
                    <th className="text-left">
                      Concepto
                    </th>
                    <th className="text-center">
                      Precio
                    </th>     
                  </tr>
                </thead>
                <tbody>
                  {currentOrderItems.map((order, key) => {
                    return (
                      <tr key={key}>
                        <td className="text-left">{order.titulo}</td>
                        <td className="text-center">{order.total}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>;
    } else {
      contentToDisplay = 
        <Col xs={12}>
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Detalle de factura {this.props.match.params.orderNumber}</CardTitle>
            </CardHeader>
            <CardBody>
              <div className="text-center">
                <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando conceptos de la factura...
              </div>
              <br />
            </CardBody>
          </Card>
        </Col>;
    }

    let rightColumn = this.createRightColumn();
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          {this.state.showPopUp && this.createPopUp()}
          {this.state.popUpConfirmation}
          <Row>
            <Col md={8} xs={12}>
              {contentToDisplay}
            </Col>
            {rightColumn}
          </Row>
        </div>
      </div>
    );
  }
}

export default BillDetail;



// WEBPACK FOOTER //
// ./src/views/Bills/BillDetail.jsx